import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type AddProductDto from "./dto/add-product.dto";
import type AddProductResponse from "./dto/add-product-response.dto";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";

export const ProductEffectActions = {
  addProduct: `${Entities.Product}_addProduct`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.Product,
  initSchema,
  aliasName: DIContainerKeys.ProductService,
})
export class ProductService extends HttpService {
  @loader(Loaders.AddProductLoader)
  @flagger(Flaggers.AddProductModalFlagger)
  @action(DIContainerKeys.ProductService)
  public *addProduct(dto: AddProductDto): Generator<any, void, any> {
    
  }
}

